import React, { PureComponent, Fragment } from "react";

import ReactEcharts from "echarts-for-react";

export default class CommonVerticalBarChart extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            unselectedList: [],
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                option: null,
            },
            () => {
                var option = this.parseData(nextProps.chartData, nextProps.chartOption);

                this.setState(
                    {
                        option: option,
                    },
                    () => {}
                );
            }
        );
    };

    containsList = (element) => {
        for (var i = 0; i < this.state.unselectedList.length; i++) {
            if (this.state.unselectedList[i] == element) {
                return i;
            }
        }
        return -1;
    };

    /* option : {sort: false showSum: true, yAxis: {field:"statDate", titlePostFix: "년"}, xAxis:{name: "사용량(건)", series: [{name: "교실영어", field:"playCountClass", stack:"base"},{name: "스페셜", field:"playCountSpecial", stack:"base"}]}}*/
    parseData = (chartData, chartOption) => {
        var maxValue = 10;

        var yAxis = [];
        var series = [];
        var legend = [];
        var stacks = chartOption.stacks ? chartOption.stacks : [];

        if (chartData) {
            chartData.forEach((data) => {
                yAxis.push(data[chartOption.yAxis.field]);
            });

            if (chartOption.sort) {
                yAxis.sort((a, b) => a - b);
            }
            chartOption.xAxis.series.forEach((x) => {
                x.stack = x.stack ? x.stack : "base";
                legend.push(x.name);
                series.push({
                    ...x,
                    list: Array.from(yAxis, () => 0),
                });
                if(!chartOption.stacks) {
                    if (stacks.findIndex(s => s.stack == x.stack) < 0) {
                        stacks.push({stack: x.stack, title: x.title, showSum: false, showPercent: true, showSumTooltip: true});
                    }
                }
            });

            chartData.forEach((data) => {
                var statIndex = yAxis.indexOf(data[chartOption.yAxis.field]);
                var total = Array.from(stacks, () => 0);
                chartOption.xAxis.series.forEach((x, index) => {
                    if(!data[x.field]) {
                        data[XMLDocument.field] = 0;
                    }
                    series[index].list[statIndex] = data[x.field];
                    for(var i = 0; i < stacks.length; i++) {
                        if(stacks[i].stack == x.stack) {
                            total[i] += data[x.field];
                            break;
                        }
                    }
                });

                var totalMax = Math.max.apply(null, total);

                if (maxValue < totalMax) {
                    maxValue = totalMax;
                }
            });

            maxValue = maxValue > 1000 ? Math.ceil(maxValue / 1000) * 1000 + 200 : (maxValue > 100 ? Math.ceil(maxValue / 100) * 100 + 20 : Math.ceil(maxValue / 10) * 10 + 5);
        }
        var option = {
            grid: chartOption.grid
                ? chartOption.grid
                : {
                      left: "5%",
                  },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "cross",
                    crossStyle: {
                        color: "#999",
                    },
                },
                formatter: chartOption.tooltipFormatter ? chartOption.tooltipFormatter : (params, chart, test) => {
                    var tooltipHtml = Array.from(stacks, () => "");
                    var tooltipTitle = "";
                    var total = Array.from(stacks, () => 0);

                    params.map((e) => {
                        if (e.seriesName.indexOf("Sum-") < 0) {
                            for(var i = 0; i < stacks.length; i++) {
                                if((stacks[i].showPercent || stacks[i].showSumTooltip) && stacks[i].stack == chartOption.xAxis.series[e.seriesIndex].stack) {
                                    total[i] += e.value;
                                    break;
                                }
                            }
                        }
                    });
                    params.map((e) => {
                        if (e.seriesName.indexOf("Sum-") < 0) {
                            if (!tooltipTitle) tooltipTitle += e.name + `${chartOption.titlePostFix ? chartOption.titlePostFix : ""}<br/>`;

                            var paramData = this.props.chartData[e.dataIndex];

                            if (paramData) {
                                const stackIndex = stacks.findIndex(s => s.stack == chartOption.xAxis.series[e.seriesIndex].stack);
                                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                                if (stacks[stackIndex].showPercent) {
                                    tooltipHtml[stackIndex] += (total[stackIndex] > 0 ? ` (` + Math.round((e.value / total[stackIndex]) * 100) + "%)" : '');
                                }
                                tooltipHtml[stackIndex] += "<br/>";
                            }
                        }
                    });
                    var tooltip = tooltipTitle + (chartOption.tooltipAlign !== 'vertical' ? `<div class='row'>` : '<div class="text-left">');
                    tooltipHtml.forEach((t, index) => {
                        if(chartOption.tooltipAlign === 'vertical') {
                            if(stacks[index].title) {
                                tooltip += `<b>${stacks[index].title}</b><br/>`;
                            }
                            tooltip += t;
                            if (stacks[index].showSumTooltip) {
                                tooltip += `<b>합계: ${total[index].toLocaleString()}</b>`;
                            }
                        } else {
                            tooltip += `<div class='col text-left chart-tooltip-stack'>`;
                            if(stacks[index].title) {
                                tooltip += `<b>${stacks[index].title}</b><br/>`;
                            }
                            tooltip += t;
                            if (stacks[index].showSumTooltip) {
                                tooltip += `<b>합계: ${total[index].toLocaleString()}</b>`;
                            }
                            tooltip += `</div>`;
                        }
                    });
                    tooltip += `</div>`;

                    return tooltip;
                },
            },
            legend: {
                show: chartOption.showLegend === undefined ? true : chartOption.showLegend,
                data: legend,
                ...chartOption.legend
            },
            xAxis: [
                {
                    type: "value",
                    name: chartOption.xAxis.name,
                    min: 0,
                    max: maxValue,
                    interval: maxValue / 5,
                    axisLabel: {
                        formatter: (value) => {
                            return value.toLocaleString();
                        },
                    },
                },
            ],
            yAxis: [
                {
                    type: "category",
                    data: chartData ? chartData.map((c) => c.className) : [],
                    inverse: chartOption.yAxis.inverse === undefined ? true : chartOption.yAxis.inverse,
                    axisPointer: {
                        type: "shadow",
                    },
                    ...chartOption.yAxis.option
                },
            ],
            series: series.map((s) => {
                const nativeOption = s.option ? s.option : {};
                return {
                    name: s.name,
                    type: s.type ? s.type : "bar",
                    stack: s.stack,
                    data: s.list,
                    label: {
                        show: false,
                        position: "right",
                        formatter: (param) => {
                            if (param.value === 0) {
                                return "";
                            } else {
                                return param.value.toLocaleString();
                            }
                        }
                    },
                    ...nativeOption
                };
            }),
        };
        stacks.forEach((s, idx) => {
            if(s.showSum) {
                option.series.push({
                    name: "Sum-" + idx,
                    type: "bar",
                    stack: s.stack,
                    data: Array.from(yAxis, () => 0),
                    color: "#00fff",
                    label: {
                        show: true,
                        position: "right",
                        formatter: (params) => {
                            let total = 0;
                            option.series.forEach((serie) => {
                                if (serie.stack == s.stack && this.containsList(serie.name) == -1) {
                                    total += serie.data[params.dataIndex];
                                }
                            });
                            return total.toLocaleString();
                        },
                    },
                });
            }
        });
        return option;
    };

    _onEvent = {
        legendselectchanged: (params, chart) => {
            var isSelected = params.selected[params.name];
            var index = this.containsList(params.name);
            if (isSelected) {
                if (index != -1) {
                    this.state.unselectedList.splice(index, 1);
                }
            } else {
                if (index == -1) {
                    this.state.unselectedList.push(params.name);
                }
            }

            chart.setOption({ animation: true });
        },
        click: (params) => {
            if(this.props.onSelect && this.props.chartData[params.dataIndex]) {
                this.props.onSelect(this.props.chartData[params.dataIndex]);
            }
        },
    };

    render() {
        const { option } = this.state;

        return option ? (
            <ReactEcharts
                theme="macarons"
                style={{
                    height: "100%",
                    width: "100%",
                }}
                option={option}
                onEvents={this._onEvent}
            />
        ) : (
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <span className="dashboard-spinner spinner-lg"></span>
            </div>
        );
    }
}
